import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import {
  MAT_SNACK_BAR_DEFAULT_OPTIONS,
  MatSnackBarConfig,
  MatSnackBarModule,
} from '@angular/material/snack-bar';
import { createNoopInjectionToken } from 'ngxtension/create-injection-token';
import { AlertToastService } from './alert-toast/alert-toast.service';
import { AlertService } from './alert.service';

export const [injectFeedback, provideFeedback] =
  createNoopInjectionToken<AlertService>('AlertService');

export function provideAlertToast(): EnvironmentProviders {
  return makeEnvironmentProviders([
    MatSnackBarModule,
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useFactory: (): MatSnackBarConfig => ({
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
        panelClass: [],
      }),
    },
    AlertToastService,
    {
      provide: AlertService,
      useClass: AlertToastService,
    },
  ]);
}
